<template>
  <div class="container h-100">
    <div class="my-5">
      <div>
        <img
          src="@/assets/mobile/profile.png"
          style="width: 128px; height: 128px"
        />
      </div>
    </div>
    <div class="row mx-2">
      <div class="form-fields mb-3">
        <input
          id="name"
          v-model="form.name"
          name="name"
          type="text"
          :placeholder="$t('TXT_NAME')"
        />
      </div>
      <div class="form-fields mb-3">
        <input
          id="last_name"
          v-model="form.last_name"
          name="last_name"
          type="text"
          :placeholder="$t('TXT_LAST_NAME')"
        />
      </div>
      <div class="form-fields mb-3">
        <input
          id="email"
          v-model="form.email"
          name="email"
          type="text"
          :placeholder="$t('TXT_EMAIL')"
        />
      </div>
      <div class="form-fields mb-3">
        <input
          id="phone"
          v-model="form.phone"
          name="phone"
          type="text"
          :placeholder="$t('TXT_PHONE')"
        />
      </div>
    </div>
    <div class="py-5">
      <button class="btn button-green px-5" @click="updateProfile()">
        {{ $t("TXT_SAVE") }}
      </button>
    </div>
  </div>
</template>

<script>
import { httpClient } from "@/token/axios.js";
import { apiURL } from "@/configs/serverConfig";
export default {
  name: "ProfileView",
  data: () => {
    return {
      form: {
        name: "",
        last_name: "",
        company_name: "",
        department: "",
        email: "",
        phone: "",
      },
    };
  },
  mounted() {
    if (this.$store.state.token !== "") {
      httpClient
        .get(`${apiURL}/user`, {
          headers: {
            Accept: "application/json",
            "Content-type": "application/json",
            Authorization: `Bearer ${this.$store.state.token}`,
          },
        })
        .then((response) => {
          (this.form.name = response.data.first_name),
            (this.form.last_name = response.data.last_name),
            (this.form.email = response.data.email);
          this.form.company_name = response.data.company_name_thai;
          this.form.phone = response.data.phone_number;
        });
    } else {
      // if (this.$router.currentRoute.path.includes("mobile")) {
      this.$router.push({ name: "Signin" });
      // }
    }
  },
  methods: {
    async updateProfile() {
      const _data = {
        first_name: this.form.name,
        last_name: this.form.last_name,
        phone_number: this.form.phone,
      };

      const url = `${apiURL}/user`;

      try {
        const update = await httpClient.put(url, _data);
        if (update.status == 200) {
          this.$toast.success("บันทึกสำเร็จ");
          this.$router.push("/main");
        }
      } catch (err) {
        console.log(err);
        this.$toast.error(err.response.data.message);
      }
    },
  },
};
</script>

<style scoped>
.form-fields,
.form-fields button {
  width: 100%;
  margin: 5px 0;
  line-height: 28px;
  border-radius: 5px;
}

.form-fields input {
  width: 100%;
  line-height: 40px;
  border-radius: 5px;
  border-radius: 5px;
  border: 1px solid #51646b;
  background: unset;
  padding: 0 5px;
  font-size: 14px;
}
</style>
